import PropTypes from 'prop-types';
import { memo, forwardRef } from 'react';
import { TEXT } from '../../config/constants';
import Plus from '../icons/Plus';
import css from './ProductListItem.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var QuickAdd = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onClickAdd = _ref.onClickAdd,
      showingQuickAddButtons = _ref.showingQuickAddButtons,
      sizes = _ref.sizes,
      onAddToBag = _ref.onAddToBag;
  var multiSizes = sizes.length > 1;
  var showButtons = showingQuickAddButtons && multiSizes;
  var buttons = [];

  if (showButtons) {
    buttons = sizes.map(function (_ref2) {
      var disabled = _ref2.disabled,
          label = _ref2.label,
          value = _ref2.value;
      return /*#__PURE__*/_jsx("button", {
        "aria-label": "Click to add ".concat(label, " to your cart"),
        className: css.quickAddChoice,
        "data-ov-event": "add-to-bag",
        disabled: disabled,
        onClick: function onClick() {
          return onAddToBag(value);
        },
        type: "button",
        children: label
      }, label);
    });
  } // If we have lots of sizes, wrap the last two buttons so they'll break to their own line


  if (buttons.length > 7) {
    var btn1 = buttons.pop();
    var btn2 = buttons.pop();
    buttons.push( /*#__PURE__*/_jsxs("div", {
      className: css.quickAddLastChoices,
      children: [btn2, btn1]
    }, "quick-add-wrap-".concat(buttons[buttons.length - 1].label)));
  }

  return /*#__PURE__*/_jsxs("div", {
    className: css.quickAdd,
    children: [!showingQuickAddButtons && /*#__PURE__*/_jsxs("button", {
      className: css.quickAddButton,
      onClick: onClickAdd,
      "aria-label": "Click to ".concat(multiSizes ? 'show quick add options' : 'add to cart'),
      type: "button",
      children: [multiSizes && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Plus, {}), "Quick Add"]
      }), !multiSizes && /*#__PURE__*/_jsx(_Fragment, {
        children: TEXT.addToBag
      })]
    }), showButtons && /*#__PURE__*/_jsx("div", {
      className: css.quickAddButtons,
      ref: ref,
      children: buttons
    })]
  });
});
QuickAdd.propTypes = {
  onAddToBag: PropTypes.func.isRequired,
  onClickAdd: PropTypes.func.isRequired,
  showingQuickAddButtons: PropTypes.bool.isRequired,
  sizes: PropTypes.arrayOf(PropTypes.shape())
};
export default /*#__PURE__*/memo(QuickAdd);